/**
 * WhatsApp Floating Widget — whatsapp-widget.js
 *
 * Handles:
 * - Bounce animation after 3s delay on page load
 * - Hiding/showing widget when cart drawer opens/closes
 *
 * Positioning is CSS only: the nav clearance in component-mobile-bottom-nav.css
 * and the buy-bar clearance in section-product.css, keyed off
 * body.sticky-bar-visible. An inline style cannot win against the !important
 * rules there, so the two attempts that used to live here and in
 * product-page.js silently did nothing on mobile.
 */
(function () {
  const widget = document.getElementById('whatsapp-widget');
  if (!widget) return;

  // Add a subtle bounce animation after 3 seconds
  setTimeout(function () {
    widget.classList.add('whatsapp-float--bounce');
  }, 3000);

  // Hide widget when cart drawer is open
  document.addEventListener('cart-drawer:open', function () {
    widget.style.display = 'none';
  });

  // Show widget when cart drawer closes
  document.addEventListener('cart-drawer:close', function () {
    widget.style.display = '';
  });
})();
